"use strict";

define('rs/models/proposal',['./abstract'], function (AbstractModel) {
  var Proposal = AbstractModel.extend({
    properties: ['beginDate', 'endDate', 'id', 'leadFirstName', 'leadLastName', 'leadPersonId', 'number', 'status', 'title'],
    getLeadDisplayName: function getLeadDisplayName() {
      return this.getLeadFirstName() + ' ' + this.getLeadLastName();
    },
    getLink: function getLink() {
      return '/sp/de_general_info.cfm?' + $.param({
        prop_id: this.getId()
      });
    }
  });
  return Proposal;
});

